import $ from "jquery";
import "slick-carousel";
import jss from 'jss'
import preset from 'jss-preset-default'

class WidgetCarouselDynamic extends elementorModules.frontend.handlers.Base {
  getDefaultSettings() {
    return {
      selectors: {
        slider: ".ecf-carousel-list",
        slider_item: ".carousel-template-list-item",
        processBar: ".carousel-template-process"
      },
    };
  }

  getDefaultElements() {
    const selectors = this.getSettings("selectors");
    return {
      $slider: this.$element.find(selectors.slider),
      $slider_item: this.$element.find(selectors.slider_item),
      $processBar: this.$element.find(selectors.processBar)
    };
  }
  
  getWidth(element,width){
    if(element){
      jss.setup(preset())
      const styles = {
        width_process:{
            width:`${width}% !important`,
          }
        }
        
      const {classes} = jss.createStyleSheet(styles).attach()
      element.classList.add(classes.width_process)
    }
  }

  setHeight(element,height){
    if(element){
      jss.setup(preset())
      const styles = {
        width_process:{
            width:`${width}% !important`,
          }
        }
        
      const {classes} = jss.createStyleSheet(styles).attach()
      element.classList.add(classes.width_process)
    }
  }

  changeStatusProcess(number,slick,slidesToShow){
    let onProgress = number + slidesToShow;
    let loadProgress = (onProgress / slick.slideCount) * 100;
    return loadProgress;
  }

  startSlick(slider,THIS,processBar,slidesToShow){
    slider.on(
      "init",
      function (event, slick, currentSlide, nextSlide) {
        THIS.getWidth(processBar,THIS.changeStatusProcess(0,slick,slidesToShow));
      }
    );
  }

  beforeChangeSlick(slider,THIS,processBar,slidesToShow){
    slider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
          THIS.getWidth(processBar,THIS.changeStatusProcess(nextSlide,slick,slidesToShow));
      }
    );
  }

  checkEnableDeviceTouch(responsiveSetting,lengthSliderItem){
    let result = false
      if(responsiveSetting.length > 0){
        result = true
        responsiveSetting.forEach(item => {
          let {slidesToShow} = item.settings
          if(lengthSliderItem > slidesToShow){
            result &= true
          }else if(lengthSliderItem < slidesToShow){
            result &= false
          }
        })
      }
      return result
  }

  bindEvents() {
    const THIS = this;
    let slider = this.elements.$slider[0];
    let slider_item = $(this.elements.$slider_item);
    let processBar = this.elements.$processBar[0];
    let processPercent = processBar.querySelector('.carousel-template-process-percent');

    // Get config
    let dataConfig = slider.getAttribute('data-config');
    let config = dataConfig ? JSON.parse(atob(dataConfig)) : null;
    if(!config) return;

    let wpIsMobile = config['wpIsMobile'] ? config['wpIsMobile'] : false;
    let slidesToShow = config['slidesToShow'] ? config['slidesToShow'] : 1;
    let slidesToScroll = config['slidesToScroll'] ? config['slidesToScroll'] : 1;
    let disableCarouselMb = config['disableCarouselMB']===false ? config['disableCarouselMB'] : true;
    let maxHeight = 0;
    let checkCarouselPartner = document.querySelectorAll('.carousel-partner-card');
    let widthDevice = window.outerWidth;
    let lengthSliderItem = slider_item.length;
    let responsiveSetting = JSON.parse(config['responsive'])
    let isEnable = lengthSliderItem > slidesToShow || (wpIsMobile && THIS.checkEnableDeviceTouch(responsiveSetting,lengthSliderItem));
    if(disableCarouselMb===false && widthDevice <=768 ){
      if(checkCarouselPartner.length!=0 && widthDevice <=767){
        return
      } else if(checkCarouselPartner.length==0){
        return
      }
    };
    if ((slider && isEnable)) {

      slider = $(slider);

      !wpIsMobile && processBar && (processBar.style.display = "block");

      if(widthDevice >= 992){
        THIS.startSlick(slider,THIS,processPercent,config['slidesToShow'])
      }
      if(widthDevice >= 992){
        THIS.beforeChangeSlick(slider,THIS,processPercent,config['slidesToShow']);
      }


      slider
        .on('init', function(event, slick) {
          // let slides = slick.$slides;
        })
        .slick({
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        dots: false,
        infinite: false,
        focusOnSelect: false,
        variableWidth: true,
        nextArrow:
          '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next">Next</button>',
        prevArrow:
          '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev">Previous</button>',
        responsive: responsiveSetting
      });
      if(lengthSliderItem%2 != 0 && (widthDevice < 1024 && widthDevice > 767)){
        if(document.querySelector('.carousel-round-card')){
          slider.slick('slickAdd', '<div><div><div class="slick-item"></div></div></div>')
        }
      }
      let slickArrow = $(
        ".slick-arrow"
      );
      let slickList = $('.slick-list');
      slickArrow.hover(()=>{
        slickList.toggleClass('hover');
      })
    }
 
    if (slider_item) {
      let slider = THIS.elements.$slider[0];
      $.each(slider_item, function (index, value) {
        let heightItem;
        widthDevice <= 998 && widthDevice>560 ? heightItem = $(slider_item[index]).outerHeight() :  heightItem = $(slider_item[index]).height()
        maxHeight < heightItem ? (maxHeight = heightItem) : "";
      });
      // if(!slider.querySelector('.carousel-round-card')||!slider.querySelector('.carousel-quote-card')){
      //   $.each(slider_item, function (index, value) {
      //     $(slider_item[index]).css("min-height", `${maxHeight}px`);
      //   });
      // }
      // if(slider.querySelector('.carousel-quote-card')){
      //   if(widthDevice <= 560){
      //     let SliderItems = Array.prototype.slice.call(slider.querySelectorAll('.carousel-quote-card'))
      //     let Contents = Array.prototype.slice.call(slider.querySelectorAll('.carousel-quote-card__content'))
      //     let Containers = Array.prototype.slice.call(slider.querySelectorAll('.carousel-quote-card__container'))
      //     if(SliderItems.length > 0){
      //       SliderItems.forEach(item=>{
      //         item.style.minHeight = 'unset'
      //       })
      //     }
      //     if(Contents.length > 0){
      //       Contents.forEach(item=>{
      //         item.style.minHeight = 'unset'
      //       })
      //     }
      //     if(Containers.length > 0){
      //       Containers.forEach(item=>{
      //         item.style.minHeight = '264px'
      //       })
      //     }
      //   }
      // }
    }

    if(slider) {
      let slideElements = $(slider).find('.carousel-template-list-item');
      // this.adjustSameTitleHeight();
      // THIS.adjustSameWriteByHeight(slideElements);
      // THIS.adjustSameContentHeight(slideElements);
      THIS.adjustSameHeightBy(slideElements, '.carousel-round-card__content--title');
      THIS.adjustSameHeightBy(slideElements, '.carousel-round-card__content--writer p:eq(0)');
      THIS.adjustSameHeightBy(slideElements, '.carousel-round-card__content', true);
      THIS.adjustSameHeightBy(slideElements, '.carousel-round-card__content--des .detail');
    }
  }

  getMaxHeightBy(el, maxHeight = 0, includePadding = false) {
    if(!el) return;

    let height = includePadding ? $(el).outerHeight() : $(el).height();
    return height > maxHeight ? height : maxHeight;
  }
  
  adjustSameHeightBy(respondTo, targetClass, includePadding) {
    const THIS = this;

    let targets = respondTo.find(targetClass);
    if(!targets) return;

    let maxHeight = 0;
    targets && targets.each(function(i, targetElement) {
      maxHeight = THIS.getMaxHeightBy(targetElement, maxHeight, includePadding);
    });

    targets.css('height',maxHeight);
  }

  // Custom Round Card
  // adjustSameTitleHeight() {
  //   let maxHeight = 0;
  //   let titles = $('.carousel-round-card__content--title');
  //   titles && titles.each(function(i, titleElement) {
  //     this.getMaxHeightBy(titleElement, maxHeight);
  //   });
  //   titles.css('height',maxHeight);
  // }

  // adjustSameContentHeight(slides) {
  //   let maxHeight = 0;
  //   let content = slides.find('.carousel-round-card__content');
  //   content && content.each(function(i, contentElement) {
  //     this.getMaxHeightBy(contentElement, maxHeight);
  //   });
  //   content.css('height',maxHeight);
  // }

  // adjustSameDesHeight(slides) {
  //   let maxHeight = 0;
  //   let content = slides.find('.carousel-round-card__content--des');
  //   content && content.each(function(i, contentElement) {
  //     this.getMaxHeightBy(contentElement, maxHeight);
  //   });
  //   content.css('height',maxHeight);
  // }

  // adjustSameWriteByHeight(slides) {
  //   let maxHeight = 0;
  //   let writer = slides.find('.carousel-round-card__content--writer p:eq(0)');
  //   writer && writer.each(function(i, writerElement) {
  //     this.getMaxHeightBy(writerElement, maxHeight);
  //   });
  //   writer.css('height', maxHeight);
  // }
}

jQuery(window).on("elementor/frontend/init", () => {
  const addHandler = ($element) => {
    elementorFrontend.elementsHandler.addHandler(WidgetCarouselDynamic, {
      $element,
    });
  };

  elementorFrontend.hooks.addAction(
    "frontend/element_ready/ecf_carousel_dynamic.default",
    addHandler
  );
});
